const STORE =
  typeof window === 'undefined' ? process.env : window.APP_ENV_SETTINGS || {};
const NODE_ENV = STORE.NODE_ENV || 'development';
const TYPO3_URL = (STORE.TYPO3_URL || 'http://www.test.ni.de').replace(
  /\/+$/,
  '',
);
const GRAPHQL_ENDPOINT =
  STORE.GRAPHQL_ENDPOINT || `https://www.test.ni.de/graphql`;
const COOKIE_DOMAIN = STORE.COOKIE_DOMAIN || '.test.ni.de';
const { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_CALLBACK_URL, AUTH0_AUDIENCE } =
  STORE;

export {
  NODE_ENV,
  TYPO3_URL,
  GRAPHQL_ENDPOINT,
  AUTH0_CLIENT_ID,
  AUTH0_DOMAIN,
  AUTH0_AUDIENCE,
  AUTH0_CALLBACK_URL,
  COOKIE_DOMAIN,
};
